import {inject, singleton} from "tsyringe";
import {ProxyService} from "../../advanced-form/proxy.service";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Project} from "../../domain/entities/project.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityChangedPayload} from "../../message-broker/payloads/entity-changed.payload";
import {CommandBus} from "../../services/command-bus.service";
import {ICommand} from "../i-command.interface";
import {UpdateProjectCommand} from "../update-project.command";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(UpdateProjectCommand)
@singleton()
export class UpdateProjectCommandHandler implements ICommandHandler<Project> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker,
        @inject(ProxyService) private readonly _proxyService: ProxyService
    ) {
    }

    public async handle(command: ICommand<Project>): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        const project = command.payload;
        this._messageBroker.publish<EntityChangedPayload<Project>>({
            type: `entity.changed`,
            identityHash: project.uid,
            payload: {
                uid: project.uid,
                prototype: Project,
                changeSet: project.changeSet,
            }
        });
        project.markAsPersisted();
        this._proxyService.commit(project.uid);
    }

}